import basedPostUrlRequestLogedIn from '../apiRequests/basedPostUrlRequestLogedIn';

const acctionCRMDate = async newData => {
  await basedPostUrlRequestLogedIn('/api/acction-crm-profile', newData);
};

export default acctionCRMDate;
